import Price from '@/resources/components/product/price/Price';

export function Total({ value, products_total }: { value: number; products_total?: number }) {
  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      <strong style={{ fontSize: 16 }}>Total:</strong>
      <div className="pb-4">
        <Price price={value} defaultPrice={products_total || 0} />
      </div>
    </div>
  );
}
